import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

import { getDefaultAla } from '../../../api/ala';
import {
  SliderWrapper, SliderTitle, StyledSlider,
} from './styles';

const marks = [
  {
    value: 1,
    label: 'ALA 1',
  },
  {
    value: 5,
    label: 'ALA 5',
  },
  {
    value: 10,
    label: 'ALA Fail',
  },
];

const valueLabelFormat = value => (value === 10 ? 'Fail' : value);

const AlaSlider = ({ onChange }) => {
  const [value, updateValue] = useState([1, 10]);

  useEffect(() => {
    const getDefault = async () => {
      const response = await getDefaultAla();
      if (response) {
        updateValue([response, value[1]]);
      }
    };

    getDefault();
  }, []);

  const valueChangeHandler = (e, newValues) => {
    updateValue(newValues);
  };

  return (
    <SliderWrapper>
      <SliderTitle>ALA Level</SliderTitle>
      <StyledSlider
        onChange={valueChangeHandler}
        onChangeCommitted={onChange}
        valueLabelFormat={valueLabelFormat}
        valueLabelDisplay="auto"
        value={value}
        max={10}
        min={1}
        marks={marks}
      />
    </SliderWrapper>
  );
};


AlaSlider.propTypes = {
  onChange: PropTypes.func,
};

export default AlaSlider;
